module.exports = __webpack_public_path__ + "favicon-96x96.png";